/**
 * 系统设置请求接口
 * @author 王振宇
 * @since 2021-04-23
 */
export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request,
    serviceForMock = _ref.serviceForMock,
    requestForMock = _ref.requestForMock,
    mock = _ref.mock,
    faker = _ref.faker,
    tools = _ref.tools;
  return {
    GET_SETTING_PAGE_LIST: function GET_SETTING_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/admin/v1/setting/getPageList',
        method: 'get',
        params: data
      });
    },
    GET_SETTING_INFO: function GET_SETTING_INFO() {
      return request({
        url: '/admin/v1/setting/info',
        method: 'get'
      });
    },
    SAVE_SETTING: function SAVE_SETTING() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/admin/v1/setting/save',
        method: 'post',
        data: data
      });
    },
    UPDATE_SETTING: function UPDATE_SETTING() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/admin/v1/setting/update',
        method: 'put',
        data: data
      });
    },
    DELETE_SETTING: function DELETE_SETTING() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/admin/v1/setting/delete',
        method: 'delete',
        data: data
      });
    },
    DELETE_BATCH_SETTING: function DELETE_BATCH_SETTING() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/admin/v1/setting/deleteBatch',
        method: 'delete',
        data: data
      });
    }
  };
});